import { render, staticRenderFns } from "./ArtisioTabs.vue?vue&type=template&id=58c67f1d&scoped=true"
import script from "./ArtisioTabs.vue?vue&type=script&lang=js"
export * from "./ArtisioTabs.vue?vue&type=script&lang=js"
import style0 from "./ArtisioTabs.vue?vue&type=style&index=0&id=58c67f1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c67f1d",
  null
  
)

export default component.exports